import { useEffect, useState } from 'react'
import { NavLink, Outlet, Link, useNavigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import './AdminLayout.css'

function AdminLayout() {
    const { usuario, carregando } = useAuth()
    const navigate = useNavigate()
    const [sidebarOpen, setSidebarOpen] = useState(false)
    const [collapsed, setCollapsed] = useState(() => {
        return localStorage.getItem('adminSidebarCollapsed') === 'true'
    })

    useEffect(() => {
        if (!carregando && (!usuario || usuario.cargo !== 'admin')) {
            navigate('/')
        }
    }, [usuario, carregando, navigate])

    if (carregando) {
        return (
            <div className="admin-loading" style={{ minHeight: '100vh' }}>
                <div className="spinner"></div>
                <span>Carregando...</span>
            </div>
        )
    }

    if (!usuario || usuario.cargo !== 'admin') {
        return null
    }

    const navItems = [
        { path: '/admin', icon: '📊', label: 'Visão Geral', end: true },
        { path: '/admin/usuarios', icon: '👥', label: 'Usuários' },
        { path: '/admin/motoristas', icon: '🚚', label: 'Motoristas' },
        { path: '/admin/anuncios', icon: '📢', label: 'Anúncios' },
        { path: '/admin/financeiro', icon: '💰', label: 'Financeiro' },
        { path: '/admin/cupons', icon: '🎟️', label: 'Cupons' },
        { path: '/admin/logs', icon: '📋', label: 'Logs' },
    ]

    return (
        <div className="admin-layout">
            {/* Sidebar Overlay (mobile) */}
            <div
                className={`admin-sidebar-overlay ${sidebarOpen ? 'open' : ''}`}
                onClick={() => setSidebarOpen(false)}
            />

            {/* Sidebar */}
            <aside className={`admin-sidebar ${sidebarOpen ? 'open' : ''} ${collapsed ? 'collapsed' : ''}`}>
                {/* Desktop Toggle Button */}
                <button
                    className="admin-sidebar-toggle"
                    onClick={() => {
                        const newCollapsed = !collapsed
                        setCollapsed(newCollapsed)
                        localStorage.setItem('adminSidebarCollapsed', String(newCollapsed))
                    }}
                    title={collapsed ? "Expandir menu" : "Recolher menu"}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16" className={collapsed ? 'rotated' : ''}>
                        <path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
                    </svg>
                </button>

                <div className="admin-sidebar-header">
                    <Link to="/" className="admin-logo-wrapper">
                        <img src="/logo/agroov-icone-novo.png" alt="Compre Agro" className="admin-logo-img" />
                        <div className="admin-logo">
                            Compre Agro
                            <span>Painel Admin</span>
                        </div>
                    </Link>
                </div>

                <nav className="admin-sidebar-nav">
                    {navItems.map(item => (
                        <NavLink
                            key={item.path}
                            to={item.path}
                            end={item.end}
                            className={({ isActive }) => `admin-nav-link ${isActive ? 'active' : ''}`}
                            onClick={() => setSidebarOpen(false)}
                        >
                            <span className="nav-icon">{item.icon}</span>
                            <span className="nav-label">{item.label}</span>
                        </NavLink>
                    ))}
                </nav>

                <div className="admin-sidebar-footer">
                    <Link to="/" className="admin-voltar-btn">
                        <span className="nav-icon">←</span>
                        <span className="nav-label">Voltar ao Site</span>
                    </Link>
                </div>
            </aside>

            {/* Main */}
            <div className={`admin-main ${collapsed ? 'expanded' : ''}`}>
                <header className="admin-header">
                    <div className="admin-header-left">
                        <button
                            className="admin-hamburger"
                            onClick={() => setSidebarOpen(!sidebarOpen)}
                        >
                            ☰
                        </button>
                        <h2>Painel Administrativo</h2>
                    </div>
                    <div className="admin-header-right">
                        <span className="admin-user-name">{usuario.nome}</span>
                        <span className="admin-user-badge">Admin</span>
                    </div>
                </header>

                <div className="admin-content">
                    <Outlet />
                </div>
            </div>
        </div>
    )
}

export default AdminLayout
